import { BlogIndexPage } from './pages/BlogIndexPage';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AiPhotographyPage } from './pages/AiPhotographyLandingPage';
import { BlogPostPage } from './pages/BlogPostPage';
import { DealsFinderPage } from './pages/DealsFinderLandingPage';
import { GetPage } from './pages/GetPage';
import { LandingPageV2 } from './pages/LandingPageV2';
import { LandingPageV3 } from './pages/LandingPageV3';
import { QuizPage } from './pages/QuizPage';

function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPageV3 />} />
      <Route path="/v2" element={<LandingPageV2 />} />
      <Route path="/v3" element={<Navigate replace to="/" />} />
      <Route path="/blog" element={<BlogIndexPage />} />
      <Route path="/blog/:slug" element={<BlogPostPage />} />
      <Route path="/get" element={<GetPage />} />
      <Route path="/quiz" element={<QuizPage />} />
      <Route path="/features/deals-finder" element={<DealsFinderPage />} />
      <Route path="/features/ai-photography" element={<AiPhotographyPage />} />
      <Route path="/features/garage" element={<Navigate replace to="/" />} />
      <Route path="/features/finance" element={<Navigate replace to="/" />} />
      <Route path="/features/garage-finance" element={<Navigate replace to="/" />} />
    </Routes>
  );
}

export default App;
